export default __webpack_public_path__ + "static/media/404.8c602802.jpg";